export default {
  User(state, u) {
    state.user.id = u.id
    state.user.pass = u.pass
    state.user.name = u.name
    state.user.avatar = u.avatar
    state.user.level = u.level
    state.user.bean = u.bean
    state.user.tickets = u.tickets
    state.user.steam = u.steam_url
    state.user.invite = u.invite_code
	state.user.promotion_level = u.promotion_level
	state.user.total_recharge = u.total_recharge
  state.user.vip_exp = u.vip_exp
	state.user.Rebate = u.Rebate
	state.user.reg_freeze_bean = u.reg_freeze_bean
	state.user.recharge_level = u.recharge_level
	state.user.charge_rebate = u.charge_rebate
	state.user.integral = u.integral
  state.user.vipLevel=u.vipLevel
  state.user.anchor_icon=u.anchor_icon
  state.user.mobile=u.mobile
  
  },
  
  GetUserId(){
    return state.user.id;
  },

  AddInformation(store,val){
	  store.AddInformation = val
  },
  
  GetIndividualsShow(state,val){
	  state.IndividualsShow = val
  },
  
  GetroundNum(state,val){
	   state.roundNum = val
  },
  
  GetVsKaiShi(state,val){
	  state.VsKaiShi = val
  },
  
  GetKaiShiVsData(state,val){
	   state.KaiShiVsData = val
  },
  
  GetJieShuVsData(state,val){
	  state.JieShuVsData = val
  },
  
  GetVsJieShu(state,val){
  	  state.VsJieShu = val
  },
  
  GetRegisterShow(state,val){
	  state.RegisterShow = val
  },
  
  GetSignInShow(state,val){
  	  state.SignInShow = val
  },
  
  Leave(state) {
    state.user.state = false
    window.localStorage.clear()
	window.sessionStorage.clear()
  },
}